import React from "react";
import { Modal } from "antd";
import { Download } from "lucide-react";
import { Button } from "./ui/button";
import { useTranslation } from "../i18n/useTranslation";

const SDKDownloadModal = ({ visible, onClose, onDownload }) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t("sdkModalTitle")}
      open={visible}
      onCancel={onClose}
      footer={null}
      width={500}
    >
      <div className="space-y-4">
        <p className="text-gray-600">{t("sdkModalDesc")}</p>
        <div className="grid grid-cols-1 gap-4">
          <Button
            variant="blue-griadient"
            size="lg"
            onClick={() => onDownload("Linux")}
            className="justify-center"
          >
            <Download className="mr-2 h-5 w-5" />
            {t("sdkPlatformLinux")}
          </Button>
          <Button
            variant="secondary"
            size="lg"
            onClick={() => onDownload("Windows")}
            disabled
            className="justify-center"
          >
            <Download className="mr-2 h-5 w-5" />
            {t("sdkPlatformWindowsComing")}
          </Button>
          <Button
            variant="secondary"
            size="lg"
            onClick={() => onDownload("macOS")}
            disabled
            className="justify-center"
          >
            <Download className="mr-2 h-5 w-5" />
            {t("sdkPlatformMacComing")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default SDKDownloadModal;
